import { Tooltip } from 'antd';
import styles from './fiexed.module.less';
import React from 'react';

const LinkDom = () => {
  return (
    <div className={styles.domContext}>
      <div>
        <a href="https://www.messenger.com/t/DSersOfficial" target="_blank" rel="noreferrer">
          <img src="https://img.dsers.com/app_icons/info.png" /> Live Chat
        </a>
      </div>
      <div>
        <a href="mailto:support@dserspro.com" target="_blank" rel="noreferrer">
          <img src="https://img.dsers.com/app_icons/email.png" /> Emall
        </a>
      </div>
    </div>
  );
};

export const Fixed = () => {
  return (
    <div className={styles.fiexed}>
      <Tooltip placement="topLeft" overlayClassName={styles.Txt} title={LinkDom()} trigger="click">
        <a className={styles.messenger}>
          <img src="https://img.dsers.com/images/icon-messager.svg" />
        </a>
      </Tooltip>
    </div>
  );
};
